module.exports = __webpack_public_path__ + "img/mattress.b799425b.svg";